module.exports = __webpack_public_path__ + "static/media/chemicals.01032c4c.jpg";